<div *ngIf="student">
    <div class="disabledText" style="padding: 5px 10px;">
        <div style="font-size: 8pt;">Student In Focus</div>
        <student-name [firstName]="student.FirstName" [lastName]="student.LastName" [middleName]="student.MiddleName"
            [nickName]="student.NickName"></student-name>
    </div>
    <mat-divider></mat-divider>
    <div>
        <button mat-button id="btnClearStudentInFocus" class="mat-menu-item" (click)="clearStudentInFocusClick()"
            role="menuitem">
            Clear Student In Focus
        </button>
    </div>
    <mat-divider style="margin: 0 10px;"></mat-divider>

    <portal-menu [portals]="displayPortals" [navigable]="true" [selectable]="false" [topLevel]="false"
        (portalNavigated)="portalNavigated.emit()"></portal-menu>
</div>